module.exports = __webpack_public_path__ + "static/media/info-strock.96ce1574.svg";